import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useFretboardStore } from "@/stores/fretboard";
import { storeToRefs } from "pinia";
import SmartToggleSwitch from "./SmartToggleSwitch.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InstrumentSelector',
  setup(__props) {

const store = useFretboardStore();
const { isGuitar } = storeToRefs(store);

function changeInstrument(value: boolean) {
  store.setInstrument(value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SmartToggleSwitch, {
    "model-value": _unref(isGuitar),
    "left-label": "Guitar",
    "right-label": "Bass",
    "onUpdate:modelValue": changeInstrument
  }, null, 8, ["model-value"]))
}
}

})